import styled from 'styled-components';
import { gradient } from '../../../helpers/styleUtils';

const GameArticleTitleStyled = styled.header`
  font-size: calc(${props => props.theme.fonts.baseSize} + 3vmin);
  left: 50%;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: translate(-50%, -40%);
  transition: opacity ${props => props.theme.transition.durationLong} ${props => props.theme.transition.easeOut},
              transform ${props => props.theme.transition.durationLong} ${props => props.theme.transition.easeOut};
  transition-delay: 0.5s;

  .game-enter-done & {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

export const SVG = styled.svg`
  width: 175px;

  text {
    fill: ${props => props.theme.colors.quinary};
    font-size: 6px;
    text-transform: uppercase;
  }
`;

export const GameArticleTitleNumber = styled.h1`
  ${gradient.background(`45deg`, props => props.theme.colors.primary, props => props.theme.gameThemes[props.gameTheme], '0', '100%')};
  border-radius: 100%;
  box-shadow: 0 0 0 8px rgba(0,0,0,0.05);
  color: ${props => props.theme.colors.white};
  font-size: calc(${props => props.theme.fonts.baseSize} + 1vmin);
  height: calc(40px + 2vmin);
  left: 50%;
  line-height: calc(40px + 2vmin);
  margin: 0;
  position: absolute;
  text-shadow: 2px 2px rgba(0,0,0,0.15);
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(40px + 2vmin);
`;

export default GameArticleTitleStyled;


// WEBPACK FOOTER //
// ./src/components/atoms/GameArticleTitle/GameArticleTitle.styled.js